import { MOVE_LEFT, MOVE_RIGHT, MOVE_UP, MOVE_DOWN } from "../../actions";

const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case MOVE_LEFT:
      return {
        ...state,
        layer_set: state.layer_set.map((old_layer) => {
          // Filter by all selected elements
          const selectedTextElements = old_layer.text_elements.filter(
              (element) => element.is_selected,
            ),
            selectedImageElements = old_layer.image_elements.filter(
              (element) => element.is_selected,
            );

          // Find the loweset left position of all selected elements
          const furthestLeftTextElement = Math.min.apply(
            Math,
            selectedTextElements.map((obj) => {
              return obj.left_position;
            }),
          );
          const furthestLeftImageElement = Math.min.apply(
            Math,
            selectedImageElements.map((obj) => {
              return obj.left_position;
            }),
          );

          // If any selected elements have a left_position 0 or lower, prevent movement left
          function isMovable() {
            if (
              (furthestLeftTextElement <= 0 &&
                furthestLeftTextElement !== Number.NEGATIVE_INFINITY) ||
              (furthestLeftImageElement <= 0 &&
                furthestLeftImageElement !== Number.NEGATIVE_INFINITY)
            ) {
              return false;
            } else {
              return true;
            }
          }

          return {
            ...old_layer,
            text_elements: old_layer.text_elements.map((element) => {
              if (isMovable()) {
                if (element.is_selected) {
                  const leftPosition = element.left_position,
                    onePx = 1 / 72 / state.preview_scale;
                  return {
                    ...element,
                    left_position: leftPosition - onePx,
                  };
                } else {
                  return element;
                }
              } else {
                return element;
              }
            }),
            image_elements: old_layer.image_elements.map((element) => {
              if (isMovable()) {
                if (element.is_selected) {
                  const leftPosition = element.left_position,
                    onePx = 1 / 72 / state.preview_scale;
                  return {
                    ...element,
                    left_position: leftPosition - onePx,
                  };
                } else {
                  return element;
                }
              } else {
                return element;
              }
            }),
          };
        }),
      };

    case MOVE_RIGHT:
      return {
        ...state,
        layer_set: state.layer_set.map((old_layer) => {
          const layerWidth = old_layer.width;

          // Filter by all selected elements
          const selectedTextElements = old_layer.text_elements.filter(
              (element) => element.is_selected,
            ),
            selectedImageElements = old_layer.image_elements.filter(
              (element) => element.is_selected,
            );

          // Find the loweset left position of all selected elements
          const furthestRightTextElement = Math.max.apply(
            Math,
            selectedTextElements.map((obj) => {
              return obj.width + obj.left_position;
            }),
          );
          const furthestRightImageElement = Math.max.apply(
            Math,
            selectedImageElements.map((obj) => {
              return obj.width + obj.left_position;
            }),
          );

          // If any selected elements have a left_position 0 or lower, prevent movement left
          function isMovable() {
            if (
              (furthestRightTextElement >= layerWidth &&
                furthestRightTextElement !== Number.NEGATIVE_INFINITY) ||
              (furthestRightImageElement >= layerWidth &&
                furthestRightImageElement !== Number.NEGATIVE_INFINITY)
            ) {
              return false;
            } else {
              return true;
            }
          }

          return {
            ...old_layer,
            text_elements: old_layer.text_elements.map((element) => {
              if (isMovable()) {
                if (element.is_selected) {
                  const leftPosition = element.left_position,
                    onePx = 1 / 72 / state.preview_scale;
                  return {
                    ...element,
                    left_position: leftPosition + onePx,
                  };
                } else {
                  return element;
                }
              } else {
                return element;
              }
            }),
            image_elements: old_layer.image_elements.map((element) => {
              if (isMovable()) {
                if (element.is_selected) {
                  const leftPosition = element.left_position,
                    onePx = 1 / 72 / state.preview_scale;
                  return {
                    ...element,
                    left_position: leftPosition + onePx,
                  };
                } else {
                  return element;
                }
              } else {
                return element;
              }
            }),
          };
        }),
      };

    case MOVE_UP:
      return {
        ...state,
        layer_set: state.layer_set.map((old_layer) => {
          // Filter by all selected elements
          const selectedTextElements = old_layer.text_elements.filter(
              (element) => element.is_selected,
            ),
            selectedImageElements = old_layer.image_elements.filter(
              (element) => element.is_selected,
            );

          // Find the loweset left position of all selected elements
          const furthestTopTextElement = Math.min.apply(
            Math,
            selectedTextElements.map((obj) => {
              return obj.top_position;
            }),
          );
          const furthestTopImageElement = Math.min.apply(
            Math,
            selectedImageElements.map((obj) => {
              return obj.top_position;
            }),
          );

          // If any selected elements have a left_position 0 or lower, prevent movement left
          function isMovable() {
            if (
              (furthestTopTextElement <= 0 &&
                furthestTopTextElement !== Number.NEGATIVE_INFINITY) ||
              (furthestTopImageElement <= 0 &&
                furthestTopImageElement !== Number.NEGATIVE_INFINITY)
            ) {
              return false;
            } else {
              return true;
            }
          }

          return {
            ...old_layer,
            text_elements: old_layer.text_elements.map((element) => {
              if (isMovable()) {
                if (element.is_selected) {
                  const topPosition = element.top_position,
                    onePx = 1 / 72 / state.preview_scale;
                  return {
                    ...element,
                    top_position: topPosition - onePx,
                  };
                } else {
                  return element;
                }
              } else {
                return element;
              }
            }),
            image_elements: old_layer.image_elements.map((element) => {
              if (isMovable()) {
                if (element.is_selected) {
                  const topPosition = element.top_position,
                    onePx = 1 / 72 / state.preview_scale;
                  return {
                    ...element,
                    top_position: topPosition - onePx,
                  };
                } else {
                  return element;
                }
              } else {
                return element;
              }
            }),
          };
        }),
      };

    case MOVE_DOWN:
      return {
        ...state,
        layer_set: state.layer_set.map((old_layer) => {
          const layerHeight = old_layer.height;

          // Filter by all selected elements
          const selectedTextElements = old_layer.text_elements.filter(
              (element) => element.is_selected,
            ),
            selectedImageElements = old_layer.image_elements.filter(
              (element) => element.is_selected,
            );

          // Find the loweset left position of all selected elements
          const furthestBottomTextElement = Math.max.apply(
            Math,
            selectedTextElements.map((obj) => {
              return obj.height + obj.top_position;
            }),
          );
          const furthestBottomImageElement = Math.max.apply(
            Math,
            selectedImageElements.map((obj) => {
              return obj.height + obj.top_position;
            }),
          );

          // If any selected elements have a left_position 0 or lower, prevent movement left
          function isMovable() {
            if (
              (furthestBottomTextElement >= layerHeight &&
                furthestBottomTextElement !== Number.NEGATIVE_INFINITY) ||
              (furthestBottomImageElement >= layerHeight &&
                furthestBottomImageElement !== Number.NEGATIVE_INFINITY)
            ) {
              return false;
            } else {
              return true;
            }
          }

          return {
            ...old_layer,
            text_elements: old_layer.text_elements.map((element) => {
              if (isMovable()) {
                if (element.is_selected) {
                  const topPosition = element.top_position,
                    onePx = 1 / 72 / state.preview_scale;
                  return {
                    ...element,
                    top_position: topPosition + onePx,
                  };
                } else {
                  return element;
                }
              } else {
                return element;
              }
            }),
            image_elements: old_layer.image_elements.map((element) => {
              if (isMovable()) {
                if (element.is_selected) {
                  const topPosition = element.top_position,
                    onePx = 1 / 72 / state.preview_scale;
                  return {
                    ...element,
                    top_position: topPosition + onePx,
                  };
                } else {
                  return element;
                }
              } else {
                return element;
              }
            }),
          };
        }),
      };

    default:
      return state;
  }
}
